import { render, staticRenderFns } from "./PlatformUpdateBanner.vue?vue&type=template&id=19489888&scoped=true&"
import script from "./PlatformUpdateBanner.vue?vue&type=script&lang=js&"
export * from "./PlatformUpdateBanner.vue?vue&type=script&lang=js&"
import style0 from "./PlatformUpdateBanner.vue?vue&type=style&index=0&id=19489888&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19489888",
  null
  
)

export default component.exports